import type { FC } from "react";
import { IoIosClose } from "react-icons/io";
import { MoonLoader } from "react-spinners";
import { formatearNumeros } from "../../../utils/formatters";
import { useAbonoModal } from "./abonoModalHooks";
import type { AbonoModalProps } from "./types";

export const AbonoModal: FC<AbonoModalProps> = (props) => {
  const {
    abonoInput,
    applyOverpaymentSuggestedAmount,
    closeOverpaymentModal,
    handleAbonar,
    handleAbonoChange,
    handleClose,
    handleObservacionesChange,
    isSubmiting,
    observaciones,
    overpaymentModal,
    showPaymentInputs,
    title,
  } = useAbonoModal(props);

  if (!props.selectedAbono) {
    return null;
  }

  return (
    <div className="w-full min-h-screen h-screen z-10 bg-black bg-opacity-50 px-2 md:px-8 flex justify-center items-center fixed top-0 left-0">
      <div className="bg-gray-200 w-[400px] p-4 rounded-md relative flex flex-col items-center max-h-[90%] overflow-y-auto">
        <IoIosClose
          className={`absolute right-0 top-0 ${
            isSubmiting ? "cursor-not-allowed opacity-50" : "cursor-pointer"
          }`}
          size={40}
          onClick={isSubmiting ? undefined : handleClose}
        />
        <h2 className="text-center text-xl font-semibold">{title}</h2>

        {showPaymentInputs && (
          <>
            <div className="flex w-full h-[40px] border border-gray-400 rounded-md mt-2">
              <div className="h-full w-[50%] bg-gray-200 flex items-center justify-center rounded-l-md border-r border-gray-400">
                Abonar R$
              </div>
              <input
                type="number"
                className="flex-1 rounded-r-md w-[50%] px-2 focus:border-transparent focus:outline-none"
                value={abonoInput}
                onChange={(e) => handleAbonoChange(e.target.value)}
              />
            </div>
            <div className="flex w-full h-[40px] border border-gray-400 rounded-md mt-2">
              <div className="h-full w-[50%] bg-gray-200 flex items-center justify-center rounded-l-md border-r border-gray-400">
                Observaciones
              </div>
              <input
                type="text"
                className="flex-1 rounded-r-md w-[50%] px-2 focus:border-transparent focus:outline-none"
                value={observaciones}
                onChange={(e) => handleObservacionesChange(e.target.value)}
              />
            </div>
          </>
        )}

        {showPaymentInputs && (
          <button
            className="bg-[#8131bd] w-fit mt-4 text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px]"
            disabled={isSubmiting}
            onClick={handleAbonar}
          >
            {isSubmiting ? <MoonLoader size={20} color="#ffffff" /> : "Abonar"}
          </button>
        )}
      </div>

      {overpaymentModal ? (
        <div className="w-full min-h-screen h-screen z-20 bg-black bg-opacity-40 px-2 md:px-8 flex justify-center items-center fixed top-0 left-0">
          <div className="bg-gray-200 w-full max-w-[420px] p-4 rounded-md shadow-lg">
            <h2 className="text-center text-lg font-semibold uppercase">Abono excedido</h2>
            <p className="text-center mt-3 font-medium">
              El abono es mayor a la deuda restante del cliente. Ajusta el valor.
            </p>
            <p className="text-center mt-3">
              Deuda restante:{" "}
              <span className="font-semibold">
                R${formatearNumeros(overpaymentModal.deudaRestante)}
              </span>
            </p>
            <p className="text-center mt-1">
              Valor maximo permitido:{" "}
              <span className="font-semibold">
                R${formatearNumeros(overpaymentModal.montoMaximoPermitido)}
              </span>
            </p>
            <div className="flex flex-col md:flex-row gap-2 justify-center mt-4">
              <button
                type="button"
                className="bg-[#8131bd] text-white px-4 py-1 rounded-md min-w-[160px]"
                onClick={applyOverpaymentSuggestedAmount}
              >
                Ajustar valor
              </button>
              <button
                type="button"
                className="bg-white text-black border border-gray-400 px-4 py-1 rounded-md min-w-[120px]"
                onClick={closeOverpaymentModal}
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};
